import { gql } from "@apollo/client";

export const GET_PLATFORM_ADMIN_BUSINESSES = gql`
  query GetPlatformAdminBusinesses(
    $countryId: Int
    $stateCode: String
    $search: String
    $zip: String
    $status: Int
    $claimed: String
    $limit: Int
    $offset: Int
  ) {
    adminBusinessesPaged(
      countryId: $countryId
      stateCode: $stateCode
      search: $search
      zip: $zip
      status: $status
      claimed: $claimed
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        id
        businessCategoryId
        name
        description
        currency
        status
        street
        countryId
        stateId
        cityId
        address
        zipcode
        cityName
        stateName
        stateCode
        phoneNumbers {
          countryCode
          phoneNumber
        }
        faxNumber
        emails
        url
        links {
          platform
          url
        }
        stage
        createdBy
        displayOnBookingPage
        claimStatus
        exemptedPlanId
        exemptedPlanExpiresAt
        careSettings {
          afhLicenseNumber
          afhLicenseVerified
          licenseStatus
          licenseExpiresOn
          facilityStatusCode
          verificationSource
          verifiedAt
          lastCheckedAt
        }
      }
    }
  }
`;
